import { isNil } from 'lodash';

import { CommunicationWorkflowTargetOrderByName } from '@pwp-common';

import { TargetOrderByEditorOutput } from '../target-order-by-editor-output';
import { TargetOrderByFormType } from '../target-order-by-form-type';

export const formToTargetOrderByEditorOutput = (formType: TargetOrderByFormType): TargetOrderByEditorOutput => {
  if (
    isNil(formType) ||
    isNil(formType.type) ||
    !Object.values(CommunicationWorkflowTargetOrderByName).includes(formType.type)
  ) {
    return {
      type: CommunicationWorkflowTargetOrderByName.explicit,
    };
  }

  return {
    type: formType.type,
  };
};
